import { autoUpdate, flip, offset, shift, size, useFloating } from '@floating-ui/react-dom-interactions';
import { Menu } from '@headlessui/react';
import Divider from '@shared/components/Divider/Divider';
import cx from 'classnames';

import NotificationsButtonComponent from './NotificationsButtonComponent';
import NotificationsHeader from './NotificationsHeader';
import NotificationsList from './NotificationsList/NotificationsList';

const DROPDOWN_SPACE_FROM_BOTTOM = 12;

interface NotificationsDropdownButtonProps {
  className?: string;
}

const NotificationsDropdownButton = ({ className }: NotificationsDropdownButtonProps) => {
  const { x, y, reference, floating, strategy } = useFloating({
    placement: 'bottom-end',
    middleware: [
      offset(0),
      flip(),
      shift(),
      size({
        apply({ availableHeight, elements }) {
          Object.assign(elements.floating.style, { maxHeight: `${availableHeight - DROPDOWN_SPACE_FROM_BOTTOM}px` });
        },
      }),
    ],
    whileElementsMounted: autoUpdate,
  });

  return (
    <Menu as="div" className={cx('relative h-10', className)}>
      {({ open, close }) => (
        <>
          <Menu.Button as="div" ref={reference}>
            <NotificationsButtonComponent />
          </Menu.Button>
          {open && (
            <Menu.Items
              ref={floating}
              style={{ position: strategy, top: y ?? 0, left: x ?? 0 }}
              className="z-dropdown rounded-2xl bg-white absolute w-[368px] my-2 border shadow-dropdown flex flex-col overflow-hidden"
            >
              <NotificationsHeader onMarkAllAsRead={close} />
              <Divider />
              <NotificationsList />
            </Menu.Items>
          )}
        </>
      )}
    </Menu>
  );
};

export default NotificationsDropdownButton;
